import { useCallback, useEffect, useState, useTransition } from 'react';
import { ContentContainer } from '../../../../../components/Filters/components/ContentContainer';
import { ControlsPanel } from '../../../../../components/Filters/components/ControlsPanel';
import { FilterLoader } from '../../../../../components/Filters/components/FilterLoader';
import { TreeSelector } from '../../../../../components/TreeSelector/TreeSelector';
import { API, ShareAPI } from '../../../../../API';
import { useBreakdownsFilterContext } from '../BreakdownsFilterContext';

export const GeoGroupChooser = () => {
  const { state, isShare, updateDraftFilters } = useBreakdownsFilterContext();
  const api = isShare ? ShareAPI : API;
  const [geoRegionsData, setGeoRegionsData] = useState(null);
  const [isPending, startTransition] = useTransition();

  const selected = state.draftFilters.geoGroup.value;

  const getGeoRegions = useCallback(() => {
    startTransition(() => {
      api.fetch('GET', `/API/v2/country-groups?category_type=GEO`)
        .then((data) => {
          setGeoRegionsData(data);
        })
        .catch((error) => {
          console.error('Failed to fetch geo regions:', error);
        });
    });
  }, [api]);

  useEffect(() => {
    getGeoRegions();
  }, [getGeoRegions]);

  const handleChange = useCallback((selectedIds) => {
    updateDraftFilters({
      geoGroup: {
        value: selectedIds.map(id => Number(id)),
        exclude: state.draftFilters.geoGroup.exclude,
      },
    });
  }, [state.draftFilters.geoGroup.exclude, updateDraftFilters]);

  const handleClearAll = () => {
    updateDraftFilters({
      geoGroup: {
        value: [],
        exclude: false,
      },
    });
  };

  return (
    <ContentContainer
      actionsComponent={
        <ControlsPanel
          id="breakdown-geo-group-filter"
          count={state.draftFilters.geoGroup.value.length}
          isExclude={state.draftFilters.geoGroup.exclude}
          showExcludeSwitch={true}
          showSelectAll={false}
          onClearAll={handleClearAll}
          onExcludeClick={() => {
            updateDraftFilters({
              geoGroup: {
                value: state.draftFilters.geoGroup.value,
                exclude: !state.draftFilters.geoGroup.exclude,
              },
            });
          }}
        />
      }
    >
      {isPending && !geoRegionsData ? (
        <FilterLoader />
      ) : (
        <TreeSelector
          items={geoRegionsData}
          selectedIds={selected}
          onChange={handleChange}
          idKey="id"
          labelKey="name"
          multiple={true}
          disabled={false}
          groupBy={(item) => item.category.name}
          mode="modern"
        />
      )}
    </ContentContainer>
  );
};
